import "core-js/modules/es6.number.constructor";
/* 弹框组件
 * <SlideBox :isShow.sync="isShow" type="bottom"></SlideBox>
 * isShow: Boolean 控制弹框显示的变量
 */
export default {
  name: 'SlideBox',
  props: {
    isShow: {
      //控制弹框显示
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    canMaskClose: {
      //mask层是否可点击关闭弹框，默认true
      type: Boolean,
      default: true
    },
    type: {
      //弹框从什么位置滑出来，默认bottom 可选值 bottom|top|left|right
      type: [String],
      default: "bottom"
    },
    pushStatus: {
      //是否需要history.pushState()，默认true
      type: [Boolean, Number],
      default: true
    }
  },
  watch: {
    isShow: function isShow(newValue) {
      document.body.style.overflow = newValue ? 'hidden' : '';
      document.documentElement.style.overflow = newValue ? 'hidden' : '';
      if (this.pushStatus) {
        if (newValue) {
          history.replaceState("beforeSlideBox_".concat(this._uid), "", "");
          history.pushState("afterSlideBox_".concat(this._uid), "", "");
        } else {
          history.state == "afterSlideBox_".concat(this._uid) && history.go(-1);
        }
      }
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    if (this.pushStatus) {
      if (history.state == "afterSlideBox_".concat(this._uid)) {
        console.log("在弹框未关闭的情况下，刷新页面，需要清除一次state");
        history.go(-1);
      }
      window.addEventListener('popstate', function (event) {
        if (event.state == "beforeSlideBox_".concat(_this._uid)) {
          _this.onClose();
        }
      });
    }
  },
  methods: {
    onClose: function onClose(type) {
      if (type === 'mask' && !this.canMaskClose) return;
      this.$emit('close');
      this.$emit('update:isShow', false);
    }
  }
};